import { render, staticRenderFns } from "./StoreBox.vue?vue&type=template&id=0417e7bf&scoped=true"
import script from "./StoreBox.vue?vue&type=script&lang=js"
export * from "./StoreBox.vue?vue&type=script&lang=js"
import style0 from "./StoreBox.vue?vue&type=style&index=0&id=0417e7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0417e7bf",
  null
  
)

export default component.exports